<template>
  <v-expansion-panels v-model="panels" multiple>
    <v-expansion-panel v-for="plan in plans" :key="plan.planId">
      <v-expansion-panel-header expand-icon="mdi-menu-down">
        <v-card-title
          >{{ plan.planType }}: {{ plan.formattedStartDate }}
          <client-plan-form
            :plan="plan"
            :viewOnly="viewOnly || !plan.isActive"
          ></client-plan-form>
        </v-card-title>
      </v-expansion-panel-header>
      <v-expansion-panel-content eager>
        <service-plans-table
          :planId="plan.planId"
          :viewOnly="viewOnly || !plan.isActive"
        ></service-plans-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import ClientPlanForm from "./client-plan-form";
import ServicePlansTable from "./service-plans-table";
export default {
  components: { ClientPlanForm, ServicePlansTable },
  props: ["plans", "active", "viewOnly"],
  data() {
    return {
      panels: this.active ? [...this.plans.keys()] : [],
    };
  },
};
</script>
